import { __exportAll } from "./vidstack-BLEs9rMG.js";
import { Host, effect, setAttribute } from "./vidstack-D9mvYVIz.js";
import { Poster } from "./vidstack-KSHlFG6B.js";
//#region src/elements/define/poster-element.ts
var poster_element_exports = /* @__PURE__ */ __exportAll({ MediaPosterElement: () => MediaPosterElement });
/**
* @docs {@link https://www.vidstack.io/docs/wc/player/components/display/poster}
* @example
* ```html
* <media-player>
*   <media-poster src="..." alt="Large alien ship hovering over New York."></media-poster>
* </media-player>
* ```
*/
var MediaPosterElement = class extends Host(HTMLElement, Poster) {
	static tagName = "media-poster";
	static attrs = { crossOrigin: "crossorigin" };
	#img = document.createElement("img");
	onSetup() {
		this.$state.img.set(this.#img);
	}
	onConnect() {
		const { src, alt, crossOrigin } = this.$state;
		effect(() => {
			const { loading, hidden } = this.$state;
			this.#img.style.display = loading() || hidden() ? "none" : "";
		});
		effect(() => {
			setAttribute(this.#img, "alt", alt());
			setAttribute(this.#img, "crossorigin", crossOrigin());
			setAttribute(this.#img, "src", src());
		});
		if (this.#img.parentNode !== this) this.prepend(this.#img);
	}
};
//#endregion
export { MediaPosterElement, poster_element_exports };
